module.exports = __webpack_public_path__ + "static/eames-storage-945283252da8ffc570ccb52ac4dc4ea5.jpg";